
// Sample communities data for the app
// In a production app, this would be fetched from Supabase

export const sampleCommunities = [
  {
    id: "1",
    name: "Eco Warriors",
    description: "For those committed to fighting climate change through daily actions",
    icon: "🌍",
    memberCount: 345
  },
  {
    id: "2",
    name: "Zero Waste Living",
    description: "Tips and support for reducing waste in everyday life",
    icon: "♻️",
    memberCount: 289
  },
  {
    id: "3",
    name: "Plant-Based Diet",
    description: "Transitioning to plant-based eating for environmental impact",
    icon: "🌱",
    memberCount: 423
  },
  {
    id: "4",
    name: "Clean Energy Advocates",
    description: "Promoting renewable energy solutions and reducing carbon footprint",
    icon: "⚡",
    memberCount: 178
  },
  {
    id: "5",
    name: "Ocean Guardians",
    description: "Focused on protecting marine life and reducing plastic pollution",
    icon: "🌊",
    memberCount: 256
  },
  {
    id: "6",
    name: "Sustainable Transport",
    description: "Exploring car-free lifestyles and low-impact transportation",
    icon: "🚲",
    memberCount: 145
  }
];
